import React from 'react'
import { Col, Row } from 'react-bootstrap'

function UserPersonalDetailsForm({handleSubmit , submitForm , register , t , errorMessage , errors }) {
    return (
        <div id="personalDtlTab" className="account-section hidden">
            <h4 id="PersonalDetails">{t("PersonalDetails")}</h4>
            <form onSubmit={handleSubmit((data) => submitForm(data))} aria-labelledby='PersonalDetails'>
                <div className="personal-details-form-wrap box">
                    <div >
                        <Row>
                            <Col xs="12" md="6">
                                <label htmlFor="fullNameInput"> {t("FullName")}</label>
                                <input
                                    id="fullNameInput"
                                    name="fullNameInput"
                                    {...register("fullNameInput", {
                                        required: t("Required"),
                                        pattern: {
                                            value: new RegExp(t("FullNameRegex")),
                                            message: t("FullNameRegexMsg"),
                                        },
                                    })}
                                    aria-describedby='fullNameInput-error'
                                />
                                <span className="error" id="fullNameInput-error">{errors.fullNameInput?.message}</span>
                            </Col>
                            <Col xs="12" md="6">
                                <label htmlFor="PhoneInput"> {t("Phone")}</label>
                                <input
                                    id="PhoneInput"
                                    name="PhoneInput"
                                    {...register("PhoneInput", {
                                        required: t("Required"),
                                        pattern: {
                                            value: new RegExp(t("PhoneRegex")),
                                            message: t("PhoneRegexMsg"),
                                        },
                                    })}
                                    aria-describedby="PhoneInput-error"
                                />
                                <span className="error" id="PhoneInput-error">{errors.PhoneInput?.message}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" md="6">
                                <label htmlFor="EmailInput"> {t("Email")}</label>
                                <input
                                    id="EmailInput"
                                    name="EmailInput"
                                    {...register("EmailInput", {
                                        required: t("Required"),
                                        pattern: {
                                            value: new RegExp(t("EmailRegex")),
                                            message: t("EmailRegexMsg"),
                                        },
                                    })}
                                    aria-describedby="EmailInput-error"

                                />
                                <span className="error" id="EmailInput-error">{errors.EmailInput?.message}</span>
                            </Col>
                            

                        </Row>
                        <Row>
                            <Col xs="12" md="6">
                                <input
                                    type="submit"
                                    className="btn"
                                    value={t("UpdateDetails")}
                                />
                            </Col>
                        </Row>


                    </div>
                </div>
            </form>
            <div className={!errorMessage ? "hidden" : "error-msg box"}>
                {errorMessage}
            </div>

        </div>)
}

export default UserPersonalDetailsForm